import * as React from 'react';
import { cn } from '../../utils/cn';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}
const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  ...props
}, ref) => {
  return <input type={type} className={cn('py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm placeholder:text-pl-zinc-400 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none', ' dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600', className)} ref={ref} {...props} />;
});
Input.displayName = 'Input';
export { Input };